// Module
var code = `<div id="wrapper"> <section role="main" ui-view></section> </div> <div class="{{\$ctrl.areaClass}}"> <blip-footer></blip-footer> </div> <toast></toast> `;
// Exports
module.exports = code;